import React, { useEffect } from "react";
import { animate, useMotionValue, useTransform, motion } from "framer-motion";

/**
 * Smoothly counts from the previously shown value up/down to `value`.
 * On first mount it animates 0 -> value (welcome/opening counter).
 */
export default function CountUp({
  value = 0,
  duration = 1.2,
  className,
  ...rest
}) {
  const count = useMotionValue(0);
  const rounded = useTransform(count, (v) =>
    Math.round(v).toLocaleString("tr-TR")
  );

  useEffect(() => {
    const controls = animate(count, value, {
      duration,
      ease: [0.16, 1, 0.3, 1],
    });
    return () => controls.stop();
  }, [value, duration, count]);

  return (
    <motion.span className={className} {...rest}>
      {rounded}
    </motion.span>
  );
}
